module.exports = __webpack_public_path__ + "img/square-wave.10ca2317.svg";